var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 4.16671H5.83333V6.66671H14.1667V4.16671H15.8333V8.33337H17.5V4.16671C17.5 3.25004 16.75 2.50004 15.8333 2.50004H12.35C12 1.53337 11.0833 0.833374 10 0.833374C8.91667 0.833374 8 1.53337 7.65 2.50004H4.16667C3.25 2.50004 2.5 3.25004 2.5 4.16671V15.8334C2.5 16.75 3.25 17.5 4.16667 17.5H9.16667V15.8334H4.16667V4.16671ZM10 2.50004C10.4583 2.50004 10.8333 2.87504 10.8333 3.33337C10.8333 3.79171 10.4583 4.16671 10 4.16671C9.54167 4.16671 9.16667 3.79171 9.16667 3.33337C9.16667 2.87504 9.54167 2.50004 10 2.50004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.58337L12.925 14.1667L10.4167 11.6667L9.16666 12.9167L12.925 16.6667L18.75 10.8334L17.5 9.58337Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory);
export default __webpack_public_path__ + "static/media/icon__inventory.a82038fcfe6e383ad1206a3c90b66c30.svg";
export { ForwardRef as ReactComponent };